import * as React from 'react';

export type CheckListItemStructure<T = unknown> = T & {
    id: number;
    checked: boolean;
    title: string;
    disabled?: boolean;
};

export type NestedCheckListDataStructure = CheckListItemStructure & {
    nestedItems: CheckListItemStructure[];
};

export type CheckListProps = {
    items: CheckListItemStructure[];
    onChange?: (id: number, checked: boolean) => void;
};

const CheckList: React.FC<CheckListProps> = ({ items, onChange }) => (
    <div>
        {items.map(({ checked, disabled, id, title }) => (
            <CheckListItem checked={checked} disabled={disabled} id={id} key={id} title={title} onChange={onChange} />
        ))}
    </div>
);

export type NestedCheckListProps = {
    items: NestedCheckListDataStructure[];
    onChange?: (id: number, val: boolean, isParent: boolean) => void;
};

export const NestedCheckList: React.FC<NestedCheckListProps> = ({ items, onChange }) => (
    <div>
        {items.map(({ checked, disabled, id, nestedItems, title }) => (
            <NestedCheckListItem
                checked={checked}
                disabled={disabled}
                id={id}
                key={id}
                nestedItems={nestedItems}
                title={title}
                onChange={onChange}
            />
        ))}
    </div>
);

export type NestedCheckListItemProps = NestedCheckListDataStructure & {
    onChange?: (id: number, val: boolean, isParent: boolean) => void;
};

export const NestedCheckListItem: React.FC<NestedCheckListItemProps> = ({
    checked,
    disabled = false,
    id,
    nestedItems,
    onChange = () => null,
    title,
}) => (
    <div>
        <CheckListItem
            checked={checked}
            disabled={disabled}
            id={id}
            title={title}
            onChange={(clickedId, val) => onChange(clickedId, val, true)}
        />
        <div style={{ paddingLeft: '8px' }}>
            {nestedItems.map(child => (
                <CheckListItem
                    checked={child.checked}
                    disabled={child.disabled}
                    id={child.id}
                    key={child.id}
                    title={child.title}
                    onChange={(clickedId, val) => onChange(clickedId, val, false)}
                />
            ))}
        </div>
    </div>
);

export type CheckListItemProps = CheckListItemStructure & {
    onChange?: (id: number, checked: boolean) => void;
};

export const CheckListItem: React.FC<CheckListItemProps> = ({
    checked,
    disabled = false,
    id,
    onChange = () => null,
    title,
}) => (
    <div className="checkbox" style={{ cursor: 'pointer' }}>
        <label>
            <input
                checked={checked}
                disabled={disabled}
                style={{ cursor: 'pointer' }}
                type="checkbox"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(id, event.target.checked)}
            />
            {title}
        </label>
    </div>
);

export default CheckList;
